import React from 'react';
import { LegalDocument } from '../../components/sections/LegalDocument';
import { PageHero } from '../../components/ui/PageHero';
import { accessibilitySections } from '../../data/legal';
import { usePageMeta } from '../../hooks/usePageMeta';
export function Accessibility() {
  usePageMeta('Accessibility Statement', 'Our commitment to making the Aurevane Search Partners website accessible to everyone.');
  return <>
      <PageHero compact label="Accessibility" title="Accessibility Statement" intro="Our commitment to an inclusive website experience." data-id="element-897" data-mp="2m1y4jiza9mmb" />
      <LegalDocument sections={accessibilitySections} showReviewNote={false} data-id="element-898" data-mp="2c4a90qtusb33" />
    </>;
}